import { __exports as useThemeWithoutDefault } from "../../../_virtual/useThemeWithoutDefault.es.js";
import React__default from "react";
import require$$1 from "../../../_virtual/index.es7.js";
Object.defineProperty(useThemeWithoutDefault, "__esModule", {
  value: true
});
var default_1 = useThemeWithoutDefault.default = void 0;
var React = _interopRequireWildcard(React__default);
var _styledEngine = require$$1;
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap)
    return null;
  var r = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function(e2) {
    return e2 ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule)
    return e;
  if (null === e || "object" != typeof e && "function" != typeof e)
    return { default: e };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e))
    return t.get(e);
  var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e)
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  return n.default = e, t && t.set(e, n), n;
}
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = React.useContext(_styledEngine.ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
default_1 = useThemeWithoutDefault.default = useTheme;
export {
  default_1 as default
};
//# sourceMappingURL=useThemeWithoutDefault.es.js.map
